import {
    GET_USAGE_DETAILS_SUCCESS,
    GET_USAGE_DETAILS_FAILURE,
} from '../actions';

import { put } from 'redux-saga/effects';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';

export default function* getUsageDetails(action) {
    //debugger
    try {
        
        // const usageDetailsApiEndpoint =  `occ/v2/${localStorage.getItem(
        //     'baseSiteId'
        // )}/order/usage/details?${convertObjectToQueryParams(action.payload)}`;
        //  const response = axios.get(usageDetailsApiEndpoint);
        const response='';
        yield put({
            type: GET_USAGE_DETAILS_SUCCESS,
            payload: response.usageDetails,
        });
    } catch (e) {
        const url = `occ/v2/${localStorage.getItem('baseSiteId')}/order/usage/details`;
        logUiErrorToBackend(e, {
            apiEndPoint: url,
            requestPayload: action.payload
        });
        yield put({
            type: GET_USAGE_DETAILS_FAILURE,
            payload: {},
        });
    }
}
